module.exports = __webpack_public_path__ + "static/media/jinray-resort.1a3e6a95.jpg";